// extracted by mini-css-extract-plugin
export default {"Picture":"profilePhoto_Picture__IjpAo","Icon":"profilePhoto_Icon__DjCoD","Active":"profilePhoto_Active__zbLIK"};